import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, InputGroup } from "react-bootstrap";
import { headerSortingClasses, sortCaret } from "../../../_metronic/_helpers";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useSelector } from "react-redux";
import { Stepper, Step } from "react-form-stepper";
import { selectProduct } from "../product/productSlice";
import {
  createChangeHandler,
  getValueStatus,
  paramsCalculationType,
  showDialog,
  useForceUpdate,
} from "../../utility";
import CurrencyInput from "react-currency-input-field";
import Select from "react-select";

export const ModalStepper = ({
  show,
  setShow,
  tableData,
  setTableData,
  selectedRows,
  setSelectedRows,
}) => {
  const { SearchBar } = Search;
  const dataProduct = useSelector(selectProduct);
  const forceUpdate = useForceUpdate();
  const [step, setStep] = useState(1);
  const [tableProduct, setTableProduct] = useState([]);
  const [calculationType, setCalculationType] = useState("");
  const [qty, setQty] = useState("");
  const [percentage, setPercentage] = useState({
    Level_1: "0",
    Level_2: "0",
    Level_3: "0",
  });
  const [amount, setAmount] = useState({
    Level_1: "0",
    Level_2: "0",
    Level_3: "0",
  });

  const levels = ["Level_1", "Level_2", "Level_3"];

  const resetState = () => {
    setStep(1);
    setCalculationType("");
    setQty("");
    setPercentage({
      level_1: "0",
      level_2: "0",
      level_3: "0",
    });
    setAmount({
      level_1: "0",
      level_2: "0",
      level_3: "0",
    });
    setSelectedRows([]);
  };

  useEffect(() => {
    if (dataProduct.length > 0) {
      const initData = dataProduct.map((item, index) => ({
        ...item,
        no: index + 1,
      }));
      setTableProduct(initData);
    }
  }, [dataProduct]);

  const handleFinish = () => {
    const lastNo =
      tableData.length > 0 ? tableData[tableData.length - 1].no : 0;

    // Data yang akan ditambahkan atau diperbarui
    const initData = selectedRows.map((item, index) => ({
      ...item,
      no: lastNo + 1 + index, // Ensure unique 'no' for each item
      calculation_type: calculationType,
      min_quantity: qty,
      percentage_level_1: percentage?.Level_1 || "0", // If empty, set to "0"
      amount_level_1: amount?.Level_1 || "0",
      percentage_level_2: percentage?.Level_2 || "0", // If empty, set to "0"
      amount_level_2: amount?.Level_2 || "0",
      percentage_level_3: percentage?.Level_3 || "0", // If empty, set to "0"
      amount_level_3: amount?.Level_3 || "0",
      special_discount_bonus_items: [],
    }));

    // Update state using functional update to ensure correct state value
    setTableData((prevTableData) => [...prevTableData, ...initData]);

    // Close modal and trigger re-render if necessary
    setSelectedRows([]);
    setShow(false);
    resetState();
    forceUpdate();
  };

  const handleClose = () => {
    setShow(false);
  };

  const validateStep1 = () => {
    if (selectedRows.length === 0) {
      showDialog("Please select at least one product.");
      return false;
    }
    return true;
  };

  const validateStep2 = () => {
    if (!calculationType) {
      showDialog("Please select a calculation type.");
      return false;
    }
    if (!qty || qty <= 0) {
      showDialog("Please enter a valid quantity.");
      return false;
    }
    return true;
  };

  const validateStep3 = () => {
    for (const level of levels) {
      const percenValue = parseFloat(percentage[level]);
      const amountValue = parseFloat(amount[level]);

      if (percenValue < 0 || percenValue > 100) {
        showDialog(`Percentage for ${level} must be between 0 and 100.`);
        return false;
      }
      if (parseFloat(amountValue) < 0) {
        showDialog(`Amount for ${level} must be a positive number.`);
        return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    let isValid = false;

    if (step === 1) isValid = validateStep1();
    else if (step === 2) isValid = validateStep2();
    else if (step === 3) isValid = validateStep3();

    if (isValid && step < 3) setStep(step + 1);
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleInputLvlPercen = (e, level) => {
    let value = parseFloat(e.target.value);

    // Jika value adalah NaN, setel ke 0
    if (isNaN(value)) {
      value = 0;
    }

    // Batasi nilai antara 0 dan 100
    value = Math.max(0, Math.min(100, value));

    setPercentage((prev) => ({
      ...prev,
      [level]: value,
    }));
  };

  const handleInputLvlAmount = (value, level) => {
    // Convert input to a number and set to 0 if it's NaN
    let numericValue = parseFloat(value) || 0;

    // Prevent negative values
    if (numericValue < 0) {
      numericValue = 0;
    }

    setAmount((prev) => ({
      ...prev,
      [level]: numericValue.toString(),
    }));
  };

  const handleChangeType = createChangeHandler(setCalculationType);

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "Code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "Name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const onSelectRow = {
    mode: "checkbox",
    selected: tableProduct
      .filter((row) =>
        selectedRows.some(
          (selectedRow) => selectedRow.product_code === row.product_code
        )
      )
      .map((row) => row.no),
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, ...tableProduct]);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(
          selectedRows.filter(
            (selectedRow) => selectedRow.product_code !== row.product_code
          )
        );
      }
      return true;
    },
  };

  return (
    <Modal
      show={show}
      size="lg"
      dialogClassName="modal-80"
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title> Add Details Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stepper activeStep={step - 1} style={{ padding: "12px" }}>
          <Step label="Select Product" />
          <Step label="Input Type" />
          <Step label="Input Discount" />
        </Stepper>
        <hr />

        {step === 1 && (
          <div className="card-body pt-0 mt-5" style={{ overflowY: "scroll" }}>
            <ToolkitProvider
              keyField="no"
              data={tableProduct}
              columns={columns}
              search
            >
              {(props) => (
                <>
                  <Row>
                    <Col></Col>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div style={{ overflowY: "auto", maxHeight: "400px" }}>
                    <BootstrapTable
                      striped
                      noDataIndication="Data Not Found"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={true}
                      {...props.baseProps}
                      selectRow={onSelectRow}
                    />
                  </div>
                </>
              )}
            </ToolkitProvider>
          </div>
        )}

        {step === 2 && (
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>
                    Calculation Type <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    options={paramsCalculationType}
                    value={getValueStatus(
                      calculationType,
                      paramsCalculationType
                    )}
                    placeholder="Select ..."
                    onChange={handleChangeType}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  <b>
                    Min Qty <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="number"
                    min="0" // Membatasi input agar tidak kurang dari 0
                    onChange={(e) => {
                      const value = Math.max(0, e.target.value);
                      setQty(value);
                    }}
                    value={qty}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        )}

        {step === 3 && (
          <>
            <Form.Group as={Row}>
              {levels.map((level, index) => (
                <Col key={index} sm={12} md={6} lg={4} className="level-border">
                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={12}>
                      <b>{level.replace("_", " ")}</b>
                    </Form.Label>
                    <Col sm={4} xs={12}>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="number"
                          step="0.1"
                          onChange={(e) => handleInputLvlPercen(e, level)}
                          value={percentage[level]}
                          className="text-right"
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </Col>
                    <Col sm={8} xs={12}>
                      <InputGroup className="mb-3">
                        <CurrencyInput
                          id={`input-${level}`}
                          className="form-control text-right"
                          name={level}
                          placeholder=""
                          decimalsLimit={2}
                          onValueChange={(value) =>
                            handleInputLvlAmount(value, level)
                          }
                          groupSeparator=","
                          decimalSeparator="."
                          value={amount[level] ?? ""}
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text>Rp</InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </Col>
                  </Form.Group>
                </Col>
              ))}
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {step > 1 && (
          <Button variant="outline-danger" onClick={handlePrev}>
            Previous
          </Button>
        )}
        {step < 3 ? (
          <Button variant="danger" onClick={handleNext}>
            Next
          </Button>
        ) : (
          <Button variant="success" onClick={handleFinish}>
            Finish
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
